export const SITE_ORIGIN = "https://darsi.ma" as const;

export const brandImage = {
  horizontal: {
    src: "/images/brand/logo-horizontal.png",
    width: 226,
    height: 61,
  },
  icon: {
    src: "/images/brand/logo-icon.png",
    width: 385,
    height: 385,
  },
  openGraph: {
    src: "/images/brand/og.webp",
    width: 901,
    height: 473,
  },
} as const;

export function brandUrl(path: string): string {
  return `${SITE_ORIGIN}${path}`;
}
